import { combineReducers } from 'redux';

import staticInitializable from '../../utils/static-initializable';
import { initializeDiscussion } from '../actions';
import changeRequestsByCommentsId from './change-requests-by-comments-id';
import comments from './comments';

export default combineReducers({
  context: staticInitializable('context', initializeDiscussion),
  comments,
  usersById: staticInitializable('usersById', initializeDiscussion),
  teamsByName: staticInitializable('teamsByName', initializeDiscussion),
  changeRequestsByCommentsId,
});
